<template>
  <span class="work-interaction-utility-button">
    <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" v-model="menuActive">
      <template #activator="{ on, attrs }">
        <button v-bind="attrs" v-on="on" class="menu-button" :class="{ 'no-padding': noPadding }">
          <v-icon :size="iconSize">mdi-dots-horizontal</v-icon>
        </button>
      </template>
      <v-list class="utility-menu">
        <v-list-item @click="toggleEngaged(workId, medium)">
          <template v-if="userWorkRelationships.hasEngaged">
            <v-icon color="primary lighten-1">mdi-eye-check</v-icon>
            Previously {{ mediumSpecificVerbForEngaged(medium) }}
          </template>
          <template v-else>
            <v-icon>mdi-eye</v-icon>
            Mark as {{ mediumSpecificVerbForEngaged(medium) }}
          </template>
        </v-list-item>

        <v-list-item @click="toggleSavedForLater(workId, medium)">
          <template v-if="userWorkRelationships.savedForLater">
            <v-icon color="primary lighten-1">mdi-bookmark-check</v-icon>
            Saved for Later
          </template>
          <template v-else>
            <v-icon>mdi-bookmark</v-icon>
            Save for Later
          </template>
        </v-list-item>

        <v-list-item
          :to="{
            name: 'rate',
            query: {
              medium: medium,
              workID: workId,
            },
          }"
        >
          <v-icon>mdi-file-document-edit</v-icon>
          Write a Review
        </v-list-item>

        <v-list-item @click="menuActive = false"> Close </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
import { mapMutations } from "vuex";
// Mixins
import WatchlistAndSeen from "../mixins/watchlistAndSeen";
import deleteReview from "../mixins/deleteReview";
// Util
import { mediumSpecificVerbForEngaged } from "../util/mediumHelpers";

export default {
  name: "review-utility-button.vue",
  mixins: [deleteReview, WatchlistAndSeen],

  props: {
    iconSize: Number,
    workId: [String, Number],
    medium: String,
    noPadding: {
      type: Boolean,
      default: false,
    },
    userWorkRelationships: Object,
  },

  computed: {
    username() {
      return this.$store.state.username;
    },
  },

  data: function () {
    return {
      menuActive: false,
    };
  },

  methods: {
    mediumSpecificVerbForEngaged,
    ...mapMutations(["showSnackbar", "showReportPopup"]),

    toggleEngaged: async function (workId, medium) {
      const newStatus = !this.userWorkRelationships.hasEngaged;
      if (newStatus == true) {
        await this.markAsViewed(workId, medium);
      } else {
        await this.deleteFromViewed(workId, medium);
      }
      this.$emit("change-engaged", newStatus);
    },

    toggleSavedForLater: async function (workId, medium) {
      const newStatus = !this.userWorkRelationships.savedForLater;
      if (newStatus == true) {
        await this.saveForLater(workId, medium);
      } else {
        await this.removeFromWatchlist(workId, medium);
      }
      this.$emit("change-saved-for-later", newStatus);
    },
  },
};
</script>

<style>
.work-interaction-utility-button {
  line-height: 1;
}

.menu-button.no-padding {
  padding: 0;
}

.utility-menu .v-icon {
  margin-right: 16px;
}
</style>
